<template>
  <div class="school">
    <div class="nav-wrap" v-show="hash !== 'selection'">
      <div class="nav">
        <router-link to="#selection">
          <van-icon class="wap-nav" name="wap-nav" @click.native.once="isTagsLoaded = true"/>
        </router-link>
        <router-link v-for="item in tabs" class="nav-item" :class="{'nav-item-shrink': !item.name}"
                     :to="'#' + item.type" :replace="true">
          {{ item.label }}
        </router-link>
      </div>
    </div>

    <!-- 分类列表 -->
    <keep-alive>
      <wrap-slot key="school" v-if="hash === '' && !isCourse">
        <div class="focus-wrap">
          <div class="focus">
            <card-jewel v-for="jewel in jewelsFocusAll" class="item"
                        :card="jewel" :key="jewel.name"
                        @click.native="getCourse(jewel.name)" sm/>
            <card-jewel sm @click.native="selectTags" class="item">
              <span slot="image" class="focus-add"></span>
              <span slot="name">添加</span>
            </card-jewel>
          </div>
        </div>
        <article-list ref="school" type="school" :options="schoolOptions">
          <template slot-scope="props">
            <card-school :card="props.item"/>
          </template>
        </article-list>
      </wrap-slot>
      <wrap-slot v-for="item in tabs" :key="item.name" v-if="hash === item.type && !isCourse">
        <!--<div class="focus-wrap">-->
          <!--<div class="focus">-->
            <!--<card-jewel v-for="jewel in jewelsFocus[item.type]" class="item"-->
                        <!--:card="jewel" :key="jewel.id"-->
                        <!--@click.native="getCourse(jewel.name)" sm/>-->
            <!--<card-jewel sm @click.native="selectTags" class="item">-->
              <!--<span slot="image" class="focus-add"></span>-->
              <!--<span slot="name">添加</span>-->
            <!--</card-jewel>-->
          <!--</div>-->
        <!--</div>-->
        <article-list :type="item.type">
          <template slot-scope="props">
            <card-school :card="props.item"/>
          </template>
        </article-list>
      </wrap-slot>
    </keep-alive>

    <!-- 选择 -->
    <div v-if="isTagsLoaded" v-show="hash === 'selection'" key="selection" class="selection">
      <div class="nav-wrap">
        <div class="nav">
          <van-icon class="wap-nav" name="wap-nav" @click="cancelSelectTags"/>
        </div>
      </div>
      <div v-for="(group, type) in jewels" class="selection-group">
        <p class="selection-head">{{ group.title }}</p>
        <div class="selection-list" v-if="group.children" :key="group.title">
          <card-jewel v-for="item in group.children"
                      :key="item.name"
                      :card="item"
                      :selectable="isSelecting"
                      @click.native="getCourse(item.name, type)"
          />
        </div>
      </div>
      <div class="btn-wrap" v-show="isSelecting">
        <button class="btn" @click="getJewelsFocus">确定</button>
      </div>
    </div>

    <!-- 学习课程 -->
    <div v-if="isCourse" key="course" class="course">
      <h2 class="head">目录 <span class="amount" v-if="false">[共0篇]</span></h2>
      <article-list :type="hash" :options="courseOptions" :link-query="{course: 1}">
        <template slot-scope="props">
          <card-course :card="addStudyState(props.item)"></card-course>
        </template>
      </article-list>
    </div>

  </div>
</template>

<script>
  import ArticleList from '@/components/ArticleList'
  import CardJewel from '@/components/CardJewel'
  import CardSchool from '@/components/CardSchool'
  import CardCourse from '@/components/CardCourse'
  import WrapSlot from '@/components/WrapSlot'
  import { Icon } from 'vant'
  import { jewelTags, jewelTagsFocus, jewelTagsRecommend, setJewelTagsFocus } from '../../../static/tags'

  export default {
    name: 'ExhibitionSchool',

    components: { ArticleList, CardJewel, CardSchool, CardCourse, WrapSlot, [Icon.name]: Icon},
    
    data() {
      return {
        jewels: jewelTags,
        jewelsFocus: jewelTagsFocus,
        tabs: [
          { name: '', label: '推荐', type: ''},
          { name: 'zbdp', label: '珠宝搭配', type: 'school-pair' },
          { name: 'trbs', label: '天然宝石', type: 'school-gemstone' },
          { name: 'trys', label: '天然玉石', type: 'school-jade' },
          { name: 'yjys', label: '有机宝石', type: 'school-jade-organic' },
          // {name: 'gjs', label: '贵金属' type: 'school-noble-metal'},
          // {name: 'wwsc', label: '文玩收藏', type: 'school-collection'},
        ],
        courses: [],
        active: this.$route.fullPath || '#',
        courseOptions: null,
        isSelecting: false,
        isTagsLoaded: false
      }
    },

    computed: {
      hash() {
        return this.$route.hash.replace('#', '')
      },
      tag() {
        return this.$route.query.tag
      },
      isCourse() {
        return !!this.$route.query.course
      },
      userStudy() {
        return this.$store.state.userInfo.study || []
      },
      jewelsFocusAll() {
        let list = Object.entries(this.jewelsFocus).reduce((arr, [type, group]) => {
          return arr.concat((group || []).filter(item => {
            return item.checked
          }))
        }, []);

        if(list.length === 0) {
          list = jewelTagsRecommend
        }

        return list
      },
      schoolOptions() {
        return {
          tags: this.jewelsFocusAll.map(item => {
            return item.name
          }).join(',') || undefined
        }
      }
    },

    filters: {
      checkStudy(item, userStudy) {
        let course = userStudy.find(_item => {
          return _item.documentId === item.id
        })

        if(course) {
          item.rate = course.rate
        } else {
          item.rate = 0
        }

        return item
      }
    },

    methods: {
      getJewelsFocus() {
        this.jewelsFocus = Object.entries(this.jewels).reduce((obj, [type, group]) => {
          obj[type] = group.children.filter(item => {
            return item.checked
          })

          return obj
        }, {})

        setJewelTagsFocus(this.jewelsFocus)
        this.isSelecting = false
        this.$router.back()
        this.$refs.school.refresh()
      },

      selectTags() {
        this.isTagsLoaded = true
        this.isSelecting = true
        this.$router.push(`#selection`)
      },

      cancelSelectTags() {
        this.isSelecting = false
        this.$router.back()
      },

      // 获取课程
      getCourse(tag, type) {
        if(!this.isSelecting) {
          this.courseOptions = { tags: tag }
          this.$router.push(`?course=1&tag=${tag}#${type || this.hash}`)
        }
      },

      // 课程补充学习状态
      // addStudyState(list) {
      //   list.forEach(item => {
      //     let course = this.userStudy.find(_item => {
      //       return _item.documentId === item.id
      //     })
      //
      //     if(course) {
      //       item.rate = course.rate
      //     }
      //   })
      //
      //   return list
      // },
      addStudyState(item) {
        let course = this.userStudy.find(_item => {
          return _item.documentId === item.id
        })
        let rate = 0

        if (course) {
          rate = course.rate
        }

        this.$set(item, 'rate', rate)

        return item

      }
    },

    activated() {
      // 这里采用延时是因为在exhibition里也有activated钩子判断顶部的tab
      this.$nextTick(() => {
        this.$router.replace(this.active)
      })
    },

    beforeRouteLeave(to, from, next) {
      this.active = from.fullPath
      next()
    },

    created() {
      if (this.hash && this.hash !== 'selection') {
        this.active = this.$route.fullPath
      }

      if(this.isCourse && this.tag) {
        this.courseOptions = { tags: this.tag }
      }
    }
  }
</script>

<style lang="less" scoped>
  

  .school {
    background-color: #fff;
  }
  .nav-wrap {
    height: 40px;
  }

  .nav {
    position: fixed;
    width: 100%;
    height: 40px;
    display: flex;
    flex-flow: row nowrap;
    font-size: 14px;
    line-height: 40px;
    background-color: #F5F5F5;
    z-index: 100;

    .wap-nav {
      padding: 0 10px;
      line-height: 40px;
      color: #3b3a3f;
    }

    .nav-item {
      flex: 1;
      text-align: center;
      color: #3b3a3f;
    }

    .nav-item.nav-item-shrink {
      width: 3em;
      flex: inherit;
    }

    .nav-item.router-link-active {
      color: #e9aea8;
    }
  }

  .selection {
    .btn-wrap {
      position: fixed;
      bottom: 50px;
      left: 0;
      width: 100%;

      .btn {
        width: 100%;
        height: 47px;
        border: none;
        background-color: #e9aea8;
        color: #fff;
        font-size: 18px;
        line-height: 47px;
      }
    }
  }

  .selection-group {
    padding: 0 10px 20px;
  }

  .selection-head {
    font-size: 14px;
    line-height: 20px;
    color: #3b3a3f;
  }

  .selection-list {
    display: flex;
    flex-flow: row wrap;

    .item {
      width: 25%;
      text-align: center;
      margin: 10px 0;
    }
  }

  .focus-wrap {
    overflow-x: auto;
  }

  .focus {
    display: flex;
    flex-flow: row nowrap;

    .item {
      width: 20%;
    }
  }

  .focus-add {
    width: 0.6rem;
    height: 1px;
    background-color: #ccc;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
  }

  .focus-add::before {
    content: ' ';
    display: block;
    width: 1px;
    height: 0.6rem;
    background-color: #ccc;
    position: absolute;
    left: calc(0.3rem - 1px);
    top: -0.3rem;
  }

  .course {
    padding: 2px 20px;

    .head {
      font-size: 18px;
      line-height: 34px;
      font-weight: normal;

      .amount {
        font-size: 12px;
      }
    }
  }
</style>